var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FirstTip = FirstTip;
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _dsWeb = require("@olxbr/ds-web");
var _chatModReactComponentsWeb = require("@olxbr/chat-mod-react-components-web");
var _ModalFirstTip = require("../ModalFirstTip");
var tipTexts = _interopRequireWildcard(require("./tipTexts"));
var Lurker = _interopRequireWildcard(require("../../helpers/lurker"));
var _urls = require("../../helpers/urls");
var _jsxRuntime = require("react/jsx-runtime");
var _templateObject,
  _jsxFileName = "/Users/natalia.silva/Documents/OLX-PROJECTS/chatmod-react-components/packages/tips/src/components/FirstTip/index.js";
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof3(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function FirstTip(_ref) {
  var StyleTip = _ref.StyleTip,
    isSeller = _ref.isSeller,
    isAutoAd = _ref.isAutoAd,
    isMsite = _ref.isMsite,
    accountId = _ref.accountId,
    chatId = _ref.chatId,
    isFirstChat = _ref.isFirstChat;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showModal = _useState2[0],
    isShowModal = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    texts = _useState4[0],
    setTexts = _useState4[1];
  (0, _react.useEffect)(function () {
    if (isFirstChat) {
      setTexts(tipTexts.isFirstChat);
    } else if (isAutoAd && isSeller) {
      setTexts(tipTexts.isSellerAuto(isMsite));
    } else if (isAutoAd && !isSeller) {
      setTexts(tipTexts.isBuyerAuto(isMsite));
    } else if (!isAutoAd && isSeller) {
      setTexts(tipTexts.isSeller(isMsite));
    } else if (!isAutoAd && !isSeller) {
      setTexts(tipTexts.isBuyer(isMsite));
    }
  }, [isFirstChat, isSeller, isAutoAd]);
  if (!texts) {
    return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
  }
  var Tip = (0, _styledComponents["default"])(StyleTip || _dsWeb.Alertbox)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])([""])));
  var clickCloseModal = function clickCloseModal() {
    Lurker.clickCloseFirstTipModal({
      chat_id: chatId,
      modalId: texts.id
    });
    isShowModal(false);
  };
  var clickOpenLink = function clickOpenLink(link) {
    Lurker.clickOpenLinkModal({
      link: link,
      chat_id: chatId,
      modalId: texts.id
    });
    window.open(link, '_blank');
  };
  var clickOpenModal = function clickOpenModal() {
    if ((typeof window === "undefined" ? "undefined" : (0, _typeof2["default"])(window)) === 'object' && typeof window._mfq === 'function') {
      window._mfq.push(['tag', 'SEE_FIRST_TIP_MODAL']);
      window._mfq.push(['setVariable', 'SEE_FIRST_TIP_MODAL', 'TRUE']);
    }
    if ((typeof window === "undefined" ? "undefined" : (0, _typeof2["default"])(window)) === 'object' && typeof window.clarity === 'function') {
      window.clarity('set', 'see_security_tip', 'true');
    }
    if (isFirstChat) {
      clickOpenLink(texts.link);
    } else {
      Lurker.clickOpenFirstTipModal({
        chat_id: chatId,
        modalId: texts.id
      });
      isShowModal(true);
    }
  };
  var descriptionText = (0, _jsxRuntime.jsxs)(_chatModReactComponentsWeb.TextBody, {
    isMobile: isMsite,
    display: "inline",
    marginBottom: "--spacing-2",
    marginTop: "--spacing-2",
    children: ["Viu algum comportamento diferente do padr\xE3o? Desconfie e\xA0", (0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.LinkButton, {
      onClick: function onClick() {
        return clickOpenLink(_urls.URL_DENUNCIA);
      },
      isMobile: isMsite,
      display: "inline",
      children: "denuncie"
    }), "."]
  });
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_ModalFirstTip.ModalFirstTip, {
      isOpen: showModal,
      showEvaluation: true,
      isMsite: isMsite,
      description: descriptionText,
      texts: texts,
      idLocalStorage: "".concat(texts.id, "-").concat(accountId),
      onCloseModal: clickCloseModal,
      chatId: chatId
    }), StyleTip && (0, _jsxRuntime.jsx)(Tip, {
      icon: texts.icon,
      text: texts.description,
      onPress: clickOpenModal,
      children: texts.linkText
    }), !StyleTip && (0, _jsxRuntime.jsx)(_dsWeb.Alertbox, {
      role: "status",
      title: "",
      variant: "default",
      children: (0, _jsxRuntime.jsxs)(_dsWeb.Flex, {
        flexDirection: "column",
        children: [texts.description, (0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.LinkButton, {
          onClick: clickOpenModal,
          isMobile: isMsite,
          display: "inline",
          children: texts.linkText
        })]
      })
    })]
  });
}
var _default = FirstTip;
exports["default"] = _default;